import { put } from "../base.ehq.model";
import { serialize } from "./user-confirmation.serializer";
import { deserialize } from "../base.serializer";

export const postUserConfirmation = async (
  token: string,
  baseUrl: string,
  userId: number | string,
  body: any
): Promise<any> => {
  const queryPath = `${baseUrl}/users/${userId}/confirm`;
  try {
    const serializedBody = await serialize(body);
    const res = await put(token, queryPath, serializedBody);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};
